exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".discount-sticker{width:66px;height:66px;color:#fff;font-size:10px;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-flow:column;flex-flow:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;background:url(" + require("../images/discount-sticker.png") + ") 0 0 no-repeat;text-align:center;letter-spacing:normal;text-transform:none;font-weight:700}.discount-sticker .value{font-size:18px}.discount-sticker.btn-container{position:absolute;left:-45px;top:-10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/stylus/_discount-sicker.styl
// module id = 588
// module chunks = 4